import "./home.css"
import { Link } from 'react-router-dom';
import PapersCarousel from './papers_carousel';

export default function Home() {
  return (
    <>
      <div className="hero-section">
        <div className="hero-background">
          <div className="abstract-graphic"></div>
          <div className="gradient-overlay"></div>
        </div>
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="main-headline">Strategic Superintelligence for Discovery & Public Good</h1>
            <p className="subtitle">
            The promise of AI is that it can cut scarcity, reduce wealth inequality, and accelerate discovery, if guided. We research reinforcement learning, strategic decision-making, exploration, alignment, and law to guide it for the public benefit.
            </p>
          </div>
          
          <div className="hero-actions">
            <Link to="/about" className="primary-button">About Us</Link>
            <Link to="/publications" className="secondary-button">Research</Link>
          </div>
        </div>
      </div>

      <div className="research-areas-section">
        <div className="section-container">
          <div className="research-header">
            <h2 className="section-title">Research Areas</h2>
            {/* <p className="section-subtitle">Placing AI at the center of scientific discovery</p> */}
          </div>
          
          <div className="research-content">
            <div className="research-area">
              <div className="research-area-header">
                <span className="research-step">Track 1</span>
                <h3 className="research-category">Computer Science</h3>
              </div>
              <div className="research-description">
                <p> Key Questions: How do we work toward "strategic superintelligence" that can discover new knowledge and assist in long-term complex decision-making? How can we make systems explore the world autonomously and efficiently to seek and develop new knowledge? How do we get there in a safe and scalable way? How can we improve rational behavior in bounded systems?<br/><br/>
                  <strong>Key areas:</strong> Reinforcement learning, strategic decision-making under uncertainty, exploration, and alignment (especially <a href="https://www.polarislab.org/#/blog/statutory-construction-ai">optimal crafting of natural language laws for AI</a>).</p>
              </div>
            </div>
            
            <div className="research-area">
              <div className="research-area-header">
                <span className="research-step">Track 2</span>
                <h3 className="research-category">AI Law</h3>
              </div>
              <div className="research-description">
                <p>Key Questions: How can law facilitate safe deployment of AI that leads to distributed benefits of the technology? How can law help reduce scarcity and wealth inequality in conjunction with AI? How do we ensure that AI doesn't concentrate power? How do we help empower labor under the threat of automation? How can AI help us better understand and structure the legal system? What risks does AI pose to the legal system?<br/><br/>
                  <strong>Key Areas:</strong> Copyright, Labor, AI Governance, Statutory Interpretation.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <PapersCarousel />
    </>
  );
}
